import type { LucideIcon } from "lucide-react";
import { Check } from "lucide-react";
import type { TwoRoomPresetId } from "../../store/twoRoomPresets";

interface TwoRoomPresetCardProps {
	id: TwoRoomPresetId;
	title: string;
	description: string;
	icon: LucideIcon;
	selected: boolean;
	ariaLabel: string;
	onSelect: (preset: TwoRoomPresetId) => void;
}

export function TwoRoomPresetCard({
	id,
	title,
	description,
	icon: Icon,
	selected,
	ariaLabel,
	onSelect,
}: TwoRoomPresetCardProps) {
	return (
		<button
			type="button"
			role="radio"
			aria-checked={selected}
			aria-label={ariaLabel}
			className={`two-room-preset-card${selected ? " active" : ""}`}
			onClick={() => onSelect(id)}
		>
			<span className="two-room-preset-card__topline">
				<span className="two-room-preset-card__icon" aria-hidden="true">
					<Icon size={18} strokeWidth={1.8} />
				</span>
				{selected && (
					<span className="two-room-preset-card__check" aria-hidden="true">
						<Check size={14} strokeWidth={2.2} />
					</span>
				)}
			</span>
			<span className="two-room-preset-card__title">{title}</span>
			<span className="two-room-preset-card__description">{description}</span>
		</button>
	);
}
